<template>
    <div>{{ phonenumber }}</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useLoaders, useTaskLoader } from '@/composeables';
import { useCommonStoreRef } from '@/stores';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
    value: string | null;
}>();

// We preload the needed countries
const { Countries } = useCommonStoreRef();
const { AddLoader } = useTaskLoader();
useLoaders(AddLoader, ['COUNTRIES']);

// The internal phonenumber

const phonenumber = computed(() => {
    /// We parse the modelValue and add the parts to the phonenumber
    let phoneNumber = props.value;

    if (phoneNumber && Countries.value.length > 0) {
        // if the phonenumber starts with + or 00 we can assume it has a country code and we need to find that from the country list
        // We try and cleanup the phonenumber a bit if it doesnt start with + or 00, we check if it is atleast 10 digits, and then we try and map the first 2 or 3 digits to a country code, if we find a match we add the country code to the phonenumber and continue with the normal parsing
        if (!phoneNumber.startsWith('+') && !phoneNumber.startsWith('00')) {
            const digits = phoneNumber.replace(/[^0-9]/g, '');
            if (digits.length >= 10) {
                // We try to find a country code match with the first 3 digits, then 2 digits
                let countrycode = '';
                for (let i = 3; i >= 2; i--) {
                    const code = digits.substring(0, i);
                    const country = Countries.value.find((c) => c.DialCode === '+' + code);
                    if (country) {
                        countrycode = '+' + code;
                        break;
                    }
                }
                if (countrycode) {
                    phoneNumber = countrycode + ' ' + phoneNumber;
                }
            }
        }

        if (phoneNumber.startsWith('+') || phoneNumber.startsWith('00')) {
            // We normalize it so it starts with + instead of 00
            if (phoneNumber.startsWith('00')) {
                phoneNumber = '+' + phoneNumber.substring(2);
            }
            // We need to loop throug all the computedCountries and check if the phonenumber starts with the dialcode
            for (let i = 0; i < Countries.value.length; i++) {
                if (!Countries.value[i].DialCode?.startsWith('+')) {
                    continue;
                }
                let country = Countries.value[i];
                if (phoneNumber.startsWith(country.DialCode as string)) {
                    // We return the country code and the phonenumber without the country code
                    const countrycode = (Countries.value[i].DialCode ?? '').trim();
                    phoneNumber = phoneNumber.replace(countrycode, '').trim().replace(/ /g, '');

                    let mask = country.DialMask ?? ''; // Format: +47 ## ## ## ##

                    // We want to replace the mask with the phonenumber so we can show it correctly
                    let _pn = phoneNumber;
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '#') {
                            mask = mask.replace('#', _pn[0]);
                            _pn = _pn.substring(1);
                        }
                    }
                    return mask;
                }
            }
        }
        return phoneNumber;
    }

    return '';
});
</script>
